import { useQuery } from '@tanstack/react-query'
import * as requests from './requests'

export const KEY_GET_ACTIVE_BRANDS = 'getActiveBrands'

export const useGetActiveBrands = () =>
  useQuery({
    queryKey: [KEY_GET_ACTIVE_BRANDS],
    queryFn: () => requests.getAllActiveBrands(),
    staleTime: 600000,
    meta: {
      errorMessage: 'Erro ao buscar as marcas.'
    }
  })
